/**
 * 통화 표기 단일 출처.
 *
 * Liquid 은 `{{ price | money }}` / `{{ price | money_with_currency }}` 를
 * `settings.currency_code_enabled` 로 갈라 쓴다(snippets/price.liquid 참조).
 * 클라이언트에서 가격을 다시 그리는 쪽(EDM, 최근 본 상품, 현재 판매 팝업)이
 * 제각각 포맷하면 같은 페이지에서 "$3.00 USD" 와 "$3.00" 이 섞이므로,
 * 그 계약을 여기 한 곳에 둔다.
 *
 * 설정값(format / formatWithCurrency / currencyCodeEnabled)은
 * layout/theme.liquid 의 인라인 스크립트가 shop·settings 에서 주입한다.
 */
(function () {
  var NS = (window.WookieMoney = window.WookieMoney || {});

  var TOKEN = /\{\{\s*(\w+)\s*\}\}/;

  /** 센트 → 자릿수/구분자 규칙에 맞춘 숫자 문자열 */
  function amountString(cents, decimals, thousands, decimalSep) {
    if (isNaN(cents) || cents == null) return '0';
    var parts = (cents / 100).toFixed(decimals).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimalSep + parts[1] : whole;
  }

  /** Shopify money_format 토큰을 해석해 문자열을 만든다 */
  function render(cents, pattern) {
    if (!pattern) return null;
    var match = pattern.match(TOKEN);
    if (!match) return pattern;

    var value;
    switch (match[1]) {
      case 'amount':
        value = amountString(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = amountString(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = amountString(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = amountString(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = amountString(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = amountString(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = amountString(cents, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = amountString(cents, 2, "'", '.');
        break;
      default:
        value = amountString(cents, 2, ',', '.');
    }
    return pattern.replace(TOKEN, value);
  }

  /** Liquid `| money` 대응 */
  NS.money = function (cents) {
    return render(cents, NS.format);
  };

  /** Liquid `| money_with_currency` 대응 */
  NS.moneyWithCurrency = function (cents) {
    return render(cents, NS.formatWithCurrency) || render(cents, NS.format);
  };

  /**
   * 테마 설정(통화 코드 표시)에 따라 둘 중 하나를 고른다.
   * 설정 주입 전이거나 포맷이 없으면 null 을 돌려주니, 호출부는 기존 폴백을 유지할 것.
   */
  NS.display = function (cents) {
    if (cents == null || isNaN(cents)) return null;
    return NS.currencyCodeEnabled ? NS.moneyWithCurrency(cents) : NS.money(cents);
  };
})();
